import React, { useState, useEffect, useMemo } from "react";
import AppBar from "@mui/material/AppBar";
import Navbar from "../Navbar";
import { UrlApi } from "../../services/apirest";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  Stack,
  Grid,
  Tooltip,
  IconButton,
  TextField,
  FormControlLabel,
  Toolbar,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
//Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { logEventos } from "../../services/services";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import EditIcon from "@mui/icons-material/Edit";
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';


//CSV
import { ExportToCsv } from "export-to-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { blueGrey } from "@mui/material/colors";
import Modelos from "./Modelos";
import AddMarca from "./add/AddMarca";
import EditarMarca from "./edit/EditarMarca";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Marcas() {
    const [update, setUpdate] = useState(false);
    const [tabla, setTabla] = useState(true);
    const [modelos, setModelos] = useState(false)
    const [marca, setMarca] = useState()
    const [alta, setAlta] = useState(false)
    const [editar, setEditar] = useState(false)
  
    useEffect(() => {
      logEventos("Avista de marcas y modelos de vehiculos", "Vehiculos", "Ver las Marcas y modelos de vehiculos registrados", localStorage.getItem("user"))
  }, [])
  
    //funcion para obtener STOCK POR SUCURSAL
    const [registro, setRegistro] = useState();
  
    const obtenerRegistro = () => {
      fetch(UrlApi + "/marcas/") //cambiar fetch
        .then((data) => data.json())
        .then((data) => setRegistro(data));
    };
  
    //funcion que espera los cambios de la funcion de obtener familias
    useEffect(() => {
        obtenerRegistro();
    }, [tabla]);
  
    //funcion de actualizar la tabla
    useEffect(() => {
      if (update) obtenerRegistro();
    }, [update]);

    const handleClickVerModelos = (row) => {
      setMarca(row)
      setTabla(false);
      setModelos(true);
    };

    const handleClickNuevo = () => {
      setAlta(true);
      setTabla(false);
    };

    const handleClickEditar = (row) => {
      setMarca(row)
      setEditar(true);
      setTabla(false);
    };
    
    //************************************************///   TABLA   ///**********************************************************************************/
    const columns = useMemo(
      () => [
          {
            header: "ID",
            accessorKey: "id",
            size: 150,
          },
        { header: "Marca", accessorKey: "descripcion", size: 150 },
      ],
      []
    );
  
    // -------------------------------------------------------------------- //
  
    const muiSearchTextFieldProps = {
      placeholder: "Buscar..",
      sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
      variant: "outlined",
      color: "primary",
      size: "small",
    };
    const tableHeadCellProps = {
      align: "left",
      sx: {
        fontSize: 16,
        color: "white",
        fontWeight: "normal",
        backgroundColor: "#2471A3",
        borderColor: "black",
      },
    };
    //*************************************************************************************************************************************/
  
    const globalTheme = useTheme();
    const tableTheme = useMemo(
      () =>
        createTheme({
          palette: {
            mode: globalTheme.palette.mode,
            primary: globalTheme.palette.primary, //primary color for the table
            info: {
              main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
            },
            background: {
              default:
                globalTheme.palette.mode === "light"
                  ? "rgb(234, 239, 241)"
                  : "#000", //pure black table in dark mode for fun
            },
          },
          typography: {
            button: {
              textTransform: "none", //customize typography styles for all buttons in table by default
              fontSize: "1rem",
            },
          },
          components: {
            MuiTooltip: {
              styleOverrides: {
                tooltip: {
                  fontSize: "0.8rem",
                },
              },
            },
          },
        }),
      [globalTheme]
    );
  
    const initialState = {
      //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
      density: "compact",
      showGlobalFilter: true,
      pagination: { pageIndex: 0, pageSize: 10 },
    };
  
    return (
        <div>
          {registro && tabla ? (
            <>
        <Navbar />
        <Container maxWidth="xl" mt={1}>
            <Box mt={2} mb={4}>
              <ThemeProvider theme={tableTheme}>
                <MaterialReactTable
                  enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
                  enableGrouping // para permitir agrupar x estado x ej
                  layoutMode="grid"
                  muiTableHeadCellProps={tableHeadCellProps}
                  muiTableBodyCellProps={({ row }) => ({
                    align: "left",
                    sx: {
                      color: "black",
                      borderColor: "black",
                    },
                  })}
                  enableColumnActions={true} //los puntitos de al lado de los titulos (acciones) -> hay que activarlo para agrupar x estado x ej
                  enableColumnFilters={false} //desactiva filtros x  columna
                  enableHiding={false} // opcion de ocultar columna pero activando el enablecolumaction
                  enableDensityToggle={false} //
                  localization={MRT_Localization_ES} //idioma
                  enableColumnDragging={false} //para arrastrar columnas
                  initialState={initialState}
                  muiSearchTextFieldProps={muiSearchTextFieldProps}
                  columns={columns}
                  data={registro} //con lo q la completas (esto cambia siempre)
                  enableStickyFooter
                  enableEditing
                  positionActionsColumn="last" // posicion de la columna de acciones al final
                  // ACCIONES
                  renderToolbarInternalActions={(
                    { table } // boton para nuevo , al lado del buscar
                  ) => (
                    <>
                     {/* <Grid item xs={6} ml={2}>
                      <Button
                        type="primary"
                        variant="contained"
                        style={{ backgroundColor: blueGrey[700], color: "white" }}
                        onClick={handleExportData}
                        size="small"
                        endIcon={<FileDownloadIcon />}
                      >
                        Exportar a CSV
                      </Button>
                     </Grid> */}
                      <MRT_FullScreenToggleButton table={table} />
                    </>
                  )}
                  renderTopToolbarCustomActions={() => (
                    <>
                      <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddBoxTwoToneIcon />}
                      onClick={handleClickNuevo}
                    >
                      Nueva Marca
                    </Button>
                      <Typography variant="poster" fontSize={26}>
                        Marcas de Vehiculos
                      </Typography>
                    </>
                  )}
                  renderRowActions={(
                    { row } //las acciones del costado editar y ver
                  ) => (
                    <div>
                      <Tooltip arrow placement="left" title="Editar Marca">
                        <IconButton
                          onClick={() => handleClickEditar(row.original)}
                          color="primary"
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip arrow placement="right" title="Modelos">
                        <IconButton
                          onClick={() => handleClickVerModelos(row.original)}
                          color="primary"
                        >
                          <DirectionsCarIcon />
                        </IconButton>
                      </Tooltip>
                      
                    </div>
                  )}
                />
              </ThemeProvider>
            </Box>
        </Container>
        </>
          ) : null}
        { modelos?
          <Modelos
            marca={marca}
            modelos={setModelos}
            tabla={setTabla}
          />
        :null}
        {alta ? (
          <AddMarca
            alta={setAlta}
            tabla={setTabla}
          />
        ) : null}
        {editar ? (
          <EditarMarca
            editar={setEditar}
            tabla={setTabla}
            marca={marca}
          />
        ) : null}
      </div>
  )
}

export default Marcas